module.exports = __webpack_public_path__ + "img/employee-2.00adfde3.jpeg";